import { Injectable, Provider } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
    constructor(private readonly title: Title) {
        super();
    }

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const title = this.buildTitle(snapshot);
        this.title.setTitle(title ? `${title} | Sourcing Souk Admin` : 'Sourcing Souk Admin');
    }
}

export const providePageTitleStrategy = (): Provider => ({
    provide: TitleStrategy,
    useClass: PageTitleStrategy,
});
